import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddCardComponent } from './add-card.component';

@NgModule({
  declarations: [AddCardComponent],
  exports: [AddCardComponent],

  imports: [CommonModule, ReactiveFormsModule, FormsModule],
  providers: [],
})
export class AddCardModule {}
